import React from 'react'
import { Link } from 'react-router-dom'
import useFetchContent from '../hooks/useFetchContent'
import Seo from '../components/Seo'

const TermsConditions = () => {
  const { title, content, loading } = useFetchContent(
    'https://api-staging.sabraah.com/api/v1/users/terms-and-conditions',
    'Terms & Conditions'
  )

  return (
    <>
      <Seo
        title="SabRaah Terms & Conditions | Travel Booking Terms"
        description="Read SabRaah's Terms & Conditions covering travel bookings, payments, cancellations, refunds, user responsibilities, and platform usage."
        path="/terms-conditions"
      />

      <section className='commonBanner commonGredientBg'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              <h1>{title}</h1>
            </div>
          </div>
        </div>
      </section>

      <section className='commentTextTerms paddingCmn'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              {loading
                ? <p>Loading...</p>
                : <div dangerouslySetInnerHTML={{ __html: content }} />
              }
            </div>
          </div>
        </div>
      </section>

      <footer>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='footerLinks'>
                             <Link to="mailto:subscribe@sabraah.com">
                                contact us - subscribe@sabraah.com
                            </Link>
                            <div className='privacyLink'>
                                <Link to="/">Home</Link>
                                |
                                <Link to="/about-us">About Us</Link>
                                |
                                <Link to="/privacy-policy">Privacy Policy</Link>
                                |
                                <Link to="/terms-conditions">Terms & Conditions</Link>
                            </div>
                        </div>
                       
                    </div>
                </div>
            </div>
        </footer>
    </>
  )
}

export default TermsConditions
